import { render, staticRenderFns } from "./add-personal.vue?vue&type=template&id=1f01f824&scoped=true&"
import script from "./add-personal.vue?vue&type=script&lang=js&"
export * from "./add-personal.vue?vue&type=script&lang=js&"
import style0 from "./add-personal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./add-personal.vue?vue&type=style&index=1&id=1f01f824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f01f824",
  null
  
)

export default component.exports